import { useNavigate } from "react-router-dom";
import style from './index.module.css';
export default function Charge({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   

  return (
    <div className={style.page}>
         <div className={style.fire1} />
         <div className={style.container}>
                <div className={style.header}>
                    <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                    <div className={style.enter} onClick={() => navigate("/chat?login")}>
                        <img src='img/enter.png' alt='Войти'/>
                        <p>{login ? user?.email : 'Войти'}</p>
                    </div>
                </div>
            </div>
            <div className={style.charge}>
                <h1>Запрос на возврат средств</h1>
                <div className={style.chbox}>
                    <h3>Проверить статус заявки на возврат средств</h3>
                    <button className={style.btng} onClick={() => navigate("/status")}>Проверить</button>
                </div>
                <div className={style.chbox}>
                    <h3>Заполнить заявление на возврат средств</h3>
                    <button className={style.btn} onClick={() => navigate("/back")}>Заполнить заявление</button>
                </div>
            </div>
        
    </div>
  );
}
